import React, { useState, useCallback } from 'react';
import { Row, Col, DatePicker, TimePicker } from 'antd';
import moment from 'moment';
import Wrapper from './style';
import { Modal, Form } from '..';
import commonMessage from '../../configs/commonMessage';
import { socmedType as socMedTypeConfigs } from '../../configs/socmedType';

const timeSetter = {
  hour: 0,
  minute: 0,
  seconds: 0,
};

const Index = (props) => {
  const { isShow, onHide, onFinish, socMedType, isLoadingButton, selectedAd } =
    props;

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [form] = Form.useForm();
  const startAdDate = selectedAd?.ad?.start_date;
  const endAdDate = selectedAd?.ad?.end_date;

  const disabledStartDate = useCallback(
    (current) => {
      const parsedStartAdDate = moment(startAdDate);
      const parsedEndAdDate = moment(endAdDate);
      parsedStartAdDate.set(timeSetter);
      parsedEndAdDate.set(timeSetter);

      // checking if the ad has been started
      if (moment() >= parsedStartAdDate) {
        let upperBound = parsedStartAdDate;
        let lowerBound = parsedEndAdDate.add('days', 1);

        if (endDate) {
          // end date form
          lowerBound = endDate;
        }

        if (socMedType === socMedTypeConfigs.TWT) {
          if (endDate) {
            const tmpStart = endDate.clone().subtract(1, 'week');
            if (tmpStart > upperBound) {
              upperBound = tmpStart;
            }
          }
        }

        const tooEarly = current < upperBound;
        const tooLate = current > lowerBound;
        return tooEarly || tooLate;
      }
      return true;
    },
    [endDate, socMedType, endAdDate, startAdDate]
  );

  const disabledEndDate = useCallback(
    (current) => {
      const parsedStartAdDate = moment(startAdDate);
      const parsedEndAdDate = moment(endAdDate);
      parsedStartAdDate.set(timeSetter);
      parsedEndAdDate.set(timeSetter);

      // checking if the ad has been started
      if (moment() >= parsedStartAdDate) {
        let upperBound = parsedStartAdDate;
        let lowerBound = parsedEndAdDate.add('days', 1);

        // start date form
        if (startDate) {
          upperBound = startDate;
        }

        if (socMedType === socMedTypeConfigs.TWT) {
          if (startDate) {
            const tmpEnd = startDate.clone().add(1, 'week');
            if (tmpEnd < lowerBound) {
              lowerBound = tmpEnd;
            }
          }
        }

        const tooEarly = current < upperBound;
        const tooLate = current > lowerBound;
        return tooEarly || tooLate;
      }

      return true;
    },
    [startAdDate, endAdDate, socMedType, startDate]
  );

  const onChange = ({ value, setState }) => {
    setState(value);
  };

  return (
    <Wrapper>
      <Modal
        title="Report Date"
        isShow={isShow}
        okText="Create"
        onCancel={onHide}
        okForm="report-form"
        width={600}
        isLoadingButton={isLoadingButton}
      >
        <p className="font-paragraph black2">
          Please enter the date of the report you want to analyze
        </p>
        <Form
          layout="vertical"
          requiredMark={false}
          form={form}
          onFinish={(value) => {
            const startDateForm = value?.start_date?.format('YYYY-MM-DD');
            const startTimeForm = value?.start_time?.format('HH:mm');
            const endDateForm = value?.end_date?.format('YYYY-MM-DD');
            const endTimeForm = value?.end_time?.format('HH:mm');

            const formattedStart = moment(`${startDateForm} ${startTimeForm}`);
            const formattedEnd = moment(`${endDateForm} ${endTimeForm}`);

            onFinish({
              start_date: formattedStart,
              end_date: formattedEnd,
            });
            form.resetFields();
          }}
          name="report-form"
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label="From"
                name="start_date"
                rules={[
                  {
                    required: true,
                    message: commonMessage.required('from date'),
                  },
                ]}
              >
                <DatePicker
                  placeholder="DD/MM/YYYY"
                  format="YYYY/MM/DD"
                  autoFocus
                  value={startDate}
                  onChange={(value) => {
                    form.setFieldsValue({
                      start_time: value,
                    });
                    return onChange({ value, setState: setStartDate });
                  }}
                  disabledDate={disabledStartDate}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="start_time"
                rules={[
                  {
                    required: true,
                    message: commonMessage.required('time'),
                  },
                ]}
                className="component_twitter_report_time"
              >
                <TimePicker
                  format="hh:mm"
                  allowClear={false}
                  placeholder="Select time"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Until"
                name="end_date"
                rules={[
                  {
                    required: true,
                    message: commonMessage.required('until date'),
                  },
                ]}
              >
                <DatePicker
                  placeholder="DD/MM/YYYY"
                  format="YYYY/MM/DD"
                  onChange={(value) => {
                    form.setFieldsValue({
                      end_time: value,
                    });
                    return onChange({ value, setState: setEndDate });
                  }}
                  disabledDate={disabledEndDate}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="end_time"
                rules={[
                  {
                    required: true,
                    message: commonMessage.required('time'),
                  },
                ]}
                className="component_twitter_report_time"
              >
                <TimePicker
                  format="hh:mm"
                  allowClear={false}
                  placeholder="Select time"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Wrapper>
  );
};

export default Index;
